(function () {
  function init(wrap) {
    const productId = wrap.dataset.productId;
    const discountCode = wrap.dataset.discountCode || "BBWD";

    const radioA = wrap.querySelector(`input[type="radio"][name="rd_pricing_option_${productId}"][value="A"]`);
    const radioB = wrap.querySelector(`input[type="radio"][name="rd_pricing_option_${productId}"][value="B"]`);
    const prop = wrap.querySelector(`#rd_pricing_property_${productId}`);
    const addWithDiscountBtn = wrap.querySelector(".rd-add-with-discount");

    if (!radioA || !radioB || !prop) return;

    function setMode(mode) {
      if (mode === "A") {
        prop.value = "A: Buyback (cash-back anytime)";
        if (addWithDiscountBtn) addWithDiscountBtn.style.display = "none";
      } else {
        prop.value = ""; // No buyback for option B
        if (addWithDiscountBtn) addWithDiscountBtn.style.display = "block";
      }
    }

    radioA.addEventListener("change", () => setMode("A"));
    radioB.addEventListener("change", () => setMode("B"));

    // Initialize
    setMode(radioB.checked ? "B" : "A");

    if (addWithDiscountBtn) {
      addWithDiscountBtn.addEventListener("click", () => {
        radioB.checked = true;
        setMode("B");

        const here = window.location.pathname + window.location.search;
        const redirectBack = here.includes("?")
          ? here + "&rd_discount_applied=1"
          : here + "?rd_discount_applied=1";

        window.location.href =
          `/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(redirectBack)}`;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".rd-pricing-options").forEach(init);
  });
})();
